<div class="p-fluid p-mb-5">

  <kodit-stranka-eotpremnice-autocomplete
    (onPravnoLiceChange)="onSelectionChange($event)"
    (onNazivChange)="handleNazivChange($event)"
    (onClear)="onSelectionClear()"
    [ctrlDisabled]="disableStranka"
  ></kodit-stranka-eotpremnice-autocomplete>

  <div *ngIf="nazivNepronadjeneStranke" class="p-mt-3">
    <kodit-field
      [fieldLabel]="
        'U bazi nema rezultata za unetu vrednost [' +
        nazivNepronadjeneStranke +
        ']'
      "
    >
      <button
        pButton
        pRipple
        type="button"
        icon="fas fa-plus"
        class="p-mt-2 p-button-outlined btn-create-fizicko-lice"
        (click)="handleCreateFizickoLice()"
        label="Unesi fizičko lice"
        pTooltip="Unesite novo fizičko lice direktno sa račun forme"
      ></button>
    </kodit-field>
  </div>
</div>

<div
  [ngClass]="
    otpremnicaFormGroup.controls.strankaDto!.touched &&
    otpremnicaFormGroup.controls.strankaDto!.invalid
      ? 'stranka-invalid'
      : ''
  "
>
  <div class="p-field p-grid">
    <label class="p-col-fixed p-m-0" kodit-form-label>Naziv:</label>
    <div class="p-col stranka-text">
      <span>{{
        otpremnicaFormGroup.controls.strankaDto.value.id
          ? otpremnicaFormGroup.controls.strankaDto.value.naziv
          : otpremnicaFormGroup.controls.strankaDto.value.tipStranke ===
            fizickoLiceTip
          ? ''
          : otpremnicaFormGroup.controls.strankaDto.value.naziv
      }}</span>
    </div>
  </div>
  <div class="p-field p-grid">
    <label class="p-col-fixed p-m-0" kodit-form-label>Adresa:</label>
    <div class="p-col stranka-text">
      <span>{{
        otpremnicaFormGroup.controls.strankaDto.value.id
          ? otpremnicaFormGroup.controls.strankaDto.value.adresa
          : otpremnicaFormGroup.controls.strankaDto.value.tipStranke ===
            fizickoLiceTip
          ? ''
          : otpremnicaFormGroup.controls.strankaDto.value.adresa
      }}</span>
    </div>
  </div>
  <div class="p-field p-grid" *ngIf="!jeInostranoPravnoLice && otpremnicaFormGroup.controls.strankaDto.value.tipStranke != fizickoLiceTip">
    <label class="p-col-fixed p-m-0" kodit-form-label>PIB:</label>
    <div class="p-col stranka-text">
      <span>{{ otpremnicaFormGroup.controls.strankaDto.value.pib }}</span>
    </div>
  </div>
  <div class="p-field p-grid" *ngIf="!jeInostranoPravnoLice">
    <label class="p-col-fixed p-m-0" kodit-form-label *ngIf="otpremnicaFormGroup.controls.strankaDto.value.tipStranke !== fizickoLiceTip">MB:</label>
    <label class="p-col-fixed p-m-0" kodit-form-label *ngIf="otpremnicaFormGroup.controls.strankaDto.value.tipStranke === fizickoLiceTip">JMBG:</label>
    <div class="p-col stranka-text">
      <span>{{ otpremnicaFormGroup.controls.strankaDto.value.mb }}</span>
    </div>

  <div class="p-field p-grid" *ngIf="jeInostranoPravnoLice">
    <label class="p-col-fixed p-m-0" kodit-form-label
      >Registracioni broj:</label
    >
    <div class="p-col stranka-text">
      <span>{{
        otpremnicaFormGroup.controls.strankaDto.value.registracioniBroj
      }}</span>
    </div>
  </div>
</div>
<small
  *ngIf="
    !otpremnicaFormGroup.controls.strankaDto.valid &&
    otpremnicaFormGroup.controls.strankaDto.touched
  "
  id="stranka-help"
  class="p-invalid"
  >Morate izabrati primaoca.</small
>
<kodit-nosioc-javne-nabavke
  *ngIf="otpremnicaFormGroup.controls.strankaDto.value.jbkjs"
  [formCtrl]="otpremnicaFormGroup.controls.nosiocJavneNabavke"
></kodit-nosioc-javne-nabavke>
